import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        token: '',
        refreshToken: '',
        signedIn: false,
        tokenExpiry: null,
    },
    reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload.access
            state.refreshToken = action.payload.refresh
            state.tokenExpiry = action.payload.tokenExpiry
        },
        onSignOutSuccess: state => {
            state.signedIn = false
            state.token = ''
            state.refreshToken = ''
            state.tokenExpiry = null
        },
        setToken: (state, action) => {
            state.token = action.payload.access
            state.tokenExpiry = action.payload.tokenExpiry
        },
    },
})

export const { onSignInSuccess, onSignOutSuccess, setToken } = sessionSlice.actions

export default sessionSlice.reducer
